import { render } from "./AppHeaderAlternative.vue?vue&type=template&id=beef0364&scoped=true"
import script from "./AppHeaderAlternative.vue?vue&type=script&lang=js"
export * from "./AppHeaderAlternative.vue?vue&type=script&lang=js"

import "./AppHeaderAlternative.vue?vue&type=style&index=0&id=beef0364&lang=scss&scoped=true"
import "./AppHeaderAlternative.vue?vue&type=style&index=1&id=beef0364&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beef0364"]])

export default __exports__